import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import { FILE_URL } from "../../redux/services/apiConstant";

export default function ViewAssetModal({ handleClose, asset }) {
    if (!asset) return null; // if no data, don't render

    return (
        <Modal show={true} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Tractors & Trailers Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Label className="fw-semibold">Asset Type</Form.Label>
                        <Form.Control plaintext readOnly defaultValue={asset?.type} />
                    </Col>
                    <Col md={6}>
                        <Form.Label className="fw-semibold">Make</Form.Label>
                        <Form.Control plaintext readOnly defaultValue={asset?.make} />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Label className="fw-semibold">Model</Form.Label>
                        <Form.Control plaintext readOnly defaultValue={asset?.model} />
                    </Col>
                    <Col md={6}>
                        <Form.Label className="fw-semibold">Year</Form.Label>
                        <Form.Control plaintext readOnly defaultValue={asset?.year} />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={12}>
                        <Form.Label className="fw-semibold">VIN</Form.Label>
                        <Form.Control plaintext readOnly defaultValue={asset?.vin} />
                    </Col>
                </Row>

                {asset.dot_inspection_expiry && (
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Label className="fw-semibold">DOT Inspection Expiry</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={asset?.dot_inspection_expiry} />
                        </Col>
                        <Col md={6}>
                            <Form.Label className="fw-semibold">DOT File</Form.Label>
                            {asset.dotFile ? (
                                <a href={FILE_URL + asset?.dot_inspection_file} target="_blank" rel="noreferrer">
                                    View File
                                </a>
                            ) : (
                                <span className="text-muted">No file uploaded</span>
                            )}
                        </Col>
                    </Row>
                )}

                {asset.cab_card_expiry && (
                    <Row className="mb-3">
                        <Col md={6}>
                            <Form.Label className="fw-semibold">Cab Card Expiry</Form.Label>
                            <Form.Control plaintext readOnly defaultValue={asset.cab_card_expiry} />
                        </Col>
                        <Col md={6}>
                            <Form.Label className="fw-semibold">Cab Card File</Form.Label>
                            {asset.cab_card_file ? (
                                <a href={FILE_URL + asset?.cab_card_file} target="_blank" rel="noreferrer">
                                    View File
                                </a>
                            ) : (
                                <span className="text-muted">No file uploaded</span>
                            )}
                        </Col>
                    </Row>
                )}

                <Row>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Notify me 30 days before expiry"
                            checked={asset?.notify_me}
                            readOnly
                            disabled
                        />
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
